<template>
  <div
    class="editorial-gallery"
    v-anim-parallax-element="{
      target: 'picture',
      offset: 10,
    }"
  >
    <WidgetSliderSwiper :slides="slides" />
  </div>
</template>

<script>
export default {
  name: 'EditoriaGallery',
}
</script>

<script setup>
const props = defineProps({
  content: Object,
})

const slides = computed(() => {
  const slides = props.content.gallery.map((galleryItem) => {
    return {
      cover: galleryItem,
      title: galleryItem.title,
    }
  })
  return slides
})
</script>

<style lang="scss">
@import './style.scss';
</style>
